var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import moment from "moment";
import {callApi} from "./api";
export function checkCoupon(coupon, productId) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/payment/coupon/` + coupon + "?productId=" + productId, {});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    const couponResult = r.payload.data;
    if (!couponResult || !couponResult.coupon.valid)
      throw Error("Invalid Coupon");
    return couponResult;
  });
}
export function bookCall(reqBody) {
  return __async(this, null, function* () {
    var _a, _b;
    const {
      reason,
      start_time,
      expert_id,
      subscription_type_id,
      subscription_id,
      overage_type_id,
      payment_method_id,
      coupon,
      phone_country_id,
      phone_country_code,
      phone,
      quantity,
      metadata
    } = reqBody;
    const r = yield callApi("/call", {
      method: "POST",
      body: {
        reason: reason || "reason",
        expert_id,
        start_time: moment(start_time).toISOString(),
        planned_duration: 50,
        subscription_type_id,
        subscription_id,
        payment_method_id,
        overage_type_id,
        coupon,
        phone_country_id: String(phone_country_id),
        phone_country_code,
        phone: String(phone),
        quantity,
        metadata
      }
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function createSubscription(subscription_type_id, payment_method_id, coupon, metadata) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/subscriptions`, {
      method: "POST",
      body: {
        subscription_type_id,
        payment_method_id,
        coupon,
        metadata
      }
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function switchToSubscription(subscription_type_id, payment_method_id, coupon, metadata) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/subscriptions/switch`, {
      method: "POST",
      body: {
        subscription_type_id,
        payment_method_id,
        coupon,
        metadata
      }
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getBookingCallSubscriptions(expert_id) {
  return __async(this, null, function* () {
    var _a, _b;
    const query = expert_id ? `?expert_id=${expert_id || ""}` : "";
    const r = yield callApi("/subscriptions/booking-call" + query, {});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getSubscriptionsUnitsInfo() {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi("/subscriptions/units-info", {});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getAvailableSubscriptions() {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi("/subscriptions/available", {});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getMySubscriptions() {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi("/subscriptions/my", {});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getPaymentMethods() {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/payment/methods`, {});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function attachPaymentMethods(id) {
  return __async(this, null, function* () {
    var _a, _b, _c, _d;
    const response = yield callApi("/payment/methods", {
      method: "POST",
      body: {paymentMethodId: id}
    });
    if (!response.ok) {
      throw new Error(((_b = (_a = response.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message) || "Unexpected response");
    }
    return (_d = (_c = response == null ? void 0 : response.payload) == null ? void 0 : _c.data) == null ? void 0 : _d.response;
  });
}
export function detachPaymentMethods(id) {
  return __async(this, null, function* () {
    var _a, _b, _c, _d;
    const response = yield callApi(`/payment/methods/${id}`, {method: "DELETE"});
    if (!response.ok) {
      throw new Error(((_b = (_a = response.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message) || "Unexpected response");
    }
    return (_d = (_c = response == null ? void 0 : response.payload) == null ? void 0 : _c.data) == null ? void 0 : _d.response;
  });
}
export function cancelSubscription(id) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/subscriptions/${id}`, {method: "DELETE"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
